// Shared season-schedule helpers
export const ARTIFACTS = "https://customer-assets-0z36b82j.emergentagent.net/job_gray-spirit-gear/artifacts";

export const fmtGameDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
};
export const fmtGameTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
};
export const sortGames = (games = []) =>
  [...games].sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
export const upcomingGames = (games = [], n) => {
  const now = Date.now();
  const up = sortGames(games).filter((g) => new Date(g.datetime).getTime() >= now - 3 * 3600 * 1000);
  return n ? up.slice(0, n) : up;
};
export const seasonRecord = (games = []) => {
  let wins = 0, losses = 0;
  for (const g of games) {
    const r = (g.result || "").trim().toUpperCase();
    if (r.startsWith("W")) wins++;
    else if (r.startsWith("L")) losses++;
  }
  return { wins, losses };
};
